import { uploadDocument } from "./documentService";

export const uploadDocumentAction = (formData) => async () => {
  const response = await uploadDocument(formData);
  return response;
};